/**
 * Comparação da planilha importada com a versão em uso, pela identidade da tabela (versão + início + fim da
 * vigência). Calculada pela API do Motor Fiscal (não tem catálogo no banco).
 */
export enum IbptComparacaoVersaoEnum {
    SemVersaoEmUso = 1,
    Igual = 2,
    Posterior = 3,
    Anterior = 4,
    MesmoInicioDiferente = 5,
}
